import {
  GET_USER_DETAIL,
  PROFILE_PHOTO,
  GET_ADDRES,
  GET_BANK,
  CREATE_BANK,
  NOTIFICATIONS_LIST_API,
  GET_MUTUAL_FUND__CUSTOMER_WORKFLOW_USER_GET,
  GET_NOMINEE_LIST,
  GET_USER_SUPPORT,
  GET_SUPPORT_TICKET_TAGS,
  CREATE_NOMINEE,
  UPDATE_NOTIFICATIONS_LIST_API,
} from "./types";
import {
  USER_INFO,
  GET_USER_INFO,
  UPDATE_USER_PIC,
  GET_ADDRESS,
  GET_BANK_DETAILS,
  SELL_API,
  CREATE_BANK_ACCOUNT,
  NOTIFICATIONS_API,
  MF_USER_INFO,
  GET_NOMINEES,
  GET_TICKETS,
  GET_TICKET_TAGS,
  CREATE_SUPPORT_TICKETS,
  CREATE_NOMINEES,
  UPDATE_NOTIFICATIONS_API,
  TRANSACTION_BASE_URL
} from "../../Api/EndPoints";
import { APIClient } from "../../Api/APIClient";
import * as Models from "../../models";
const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
const USER_BASE_URL = process.env.REACT_APP_USER_BASE_URL;
export function getUserDetail(req: Models.UserInfoRequest, token: string) {
  return (dispatch: (arg0: { type: string }) => void, getState: any) =>
    new Promise((resolve, reject) => {
      dispatch({ type: GET_USER_DETAIL });
      const apiClient = APIClient.getInstance();
      if (apiClient) {
        apiClient
          .postData(API_BASE_URL + USER_INFO, JSON.stringify(req), token)
          .then((response: any) => {
            let result = response;
            resolve(result);
          })
          .catch((error: any) => {
            let errorMessage = error.message;
            reject(errorMessage);
          });
      }
    });
}

export function getUserInfo(req: Models.GETUSER_INFO_REQUEST, token: string) {
  return (dispatch: (arg0: { type: string }) => void, getState: any) =>
    new Promise((resolve, reject) => {
      dispatch({ type: GET_USER_DETAIL });
      const apiClient = APIClient.getInstance();
      if (apiClient) {
        apiClient
          .postData(API_BASE_URL + GET_USER_INFO, JSON.stringify(req), token)
          .then((response: any) => {
            let result = response;
            resolve(result);
          })
          .catch((error: any) => {
            let errorMessage = error.message;
            reject(errorMessage);
          });
      }
    });
}

export function getNomineeList(req: any, token: string) {
  return (dispatch: (arg0: { type: string }) => void, getState: any) =>
    new Promise((resolve, reject) => {
      dispatch({ type: GET_NOMINEE_LIST });
      const apiClient = APIClient.getInstance();
      if (apiClient) {
        apiClient
          .postData(API_BASE_URL + GET_NOMINEES, JSON.stringify(req), token)
          .then((response: any) => {
            let result = response;
            resolve(result);
          })
          .catch((error: any) => {
            let errorMessage = error.message;
            reject(errorMessage);
          });
      }
    });
}

export function getSupport(req: any, token: string) {
  return (dispatch: (arg0: { type: string }) => void, getState: any) =>
    new Promise((resolve, reject) => {
      dispatch({ type: GET_USER_SUPPORT });
      const apiClient = APIClient.getInstance();
      if (apiClient) {
        apiClient
          .postData(API_BASE_URL + GET_TICKETS, JSON.stringify(req), token)
          .then((response: any) => {
            let result = response;
            resolve(result);
          })
          .catch((error: any) => {
            let errorMessage = error.message;
            reject(errorMessage);
          });
      }
    });
}

export function createTickets(req: any, token: string) {
  return (dispatch: (arg0: { type: string }) => void, getState: any) =>
    new Promise((resolve, reject) => {
      dispatch({ type: GET_USER_SUPPORT });
      const apiClient = APIClient.getInstance();
      if (apiClient) {
        apiClient
          .postData(
            API_BASE_URL + CREATE_SUPPORT_TICKETS,
            JSON.stringify(req),
            token
          )
          .then((response: any) => {
            let result = response;
            resolve(result);
          })
          .catch((error: any) => {
            let errorMessage = error.message;
            reject(errorMessage);
          });
      }
    });
}

export function createNominee(req: any, token: string) {
  return (dispatch: (arg0: { type: string }) => void, getState: any) =>
    new Promise((resolve, reject) => {
      dispatch({ type: CREATE_NOMINEE });
      const apiClient = APIClient.getInstance();
      if (apiClient) {
        apiClient
          .postData(API_BASE_URL + CREATE_NOMINEES, JSON.stringify(req), token)
          .then((response: any) => {
            let result = response;
            resolve(result);
          })
          .catch((error: any) => {
            let errorMessage = error.message;
            reject(errorMessage);
          });
      }
    });
}

export function getTags(token: string) {
  return (dispatch: (arg0: { type: string }) => void, getState: any) =>
    new Promise((resolve, reject) => {
      dispatch({ type: GET_SUPPORT_TICKET_TAGS });
      const apiClient = APIClient.getInstance();
      if (apiClient) {
        apiClient
          .getRequest(API_BASE_URL + GET_TICKET_TAGS, token)
          .then((response: any) => {
            let result = response;
            resolve(result);
          })
          .catch((error: any) => {
            let errorMessage = error.message;
            reject(errorMessage);
          });
      }
    });
}

export function getAddress(phoneNumber: any, token: any) {
  return (dispatch: (arg0: { type: string }) => void, getState: any) =>
    new Promise((resolve, reject) => {
      dispatch({ type: GET_ADDRES });
      const apiClient = APIClient.getInstance();
      if (apiClient) {
        apiClient
          .getRequest(USER_BASE_URL + GET_ADDRESS + phoneNumber, token)
          .then((response: any) => {
            let result = response;
            resolve(result);
          })
          .catch((error: any) => {
            let errorMessage = error.message;
            reject(errorMessage);
          });
      }
    });
}

export function getBankDetails(phoneNumber: any, token: any) {
  return (dispatch: (arg0: { type: string }) => void, getState: any) =>
    new Promise((resolve, reject) => {
      dispatch({ type: GET_BANK });
      const apiClient = APIClient.getInstance();
      if (apiClient) {
        apiClient
          .getRequest(USER_BASE_URL + GET_BANK_DETAILS + phoneNumber, token)
          .then((response: any) => {
            let result = response;
            resolve(result);
          })
          .catch((error: any) => {
            let errorMessage = error.error;
            reject(errorMessage);
          });
      }
    });
}

export function sellData(req: any, token: string) {
  return (dispatch: (arg0: { type: string }) => void, getState: any) =>
    new Promise((resolve, reject) => {
      dispatch({ type: GET_USER_DETAIL });
      const apiClient = APIClient.getInstance();
      if (apiClient) {
        apiClient
          .postData(TRANSACTION_BASE_URL + SELL_API, JSON.stringify(req), token)
          .then((response: any) => {
            let result = response;
            resolve(result);
          })
          .catch((error: any) => {
            let errorMessage = error.message;
            reject(errorMessage);
          });
      }
    });
}

export function addBankAccount(req: any, token: string) {
  console.log(req);
  return (dispatch: (arg0: { type: string }) => void, getState: any) =>
    new Promise((resolve, reject) => {
      dispatch({ type: CREATE_BANK });
      const apiClient = APIClient.getInstance();
      if (apiClient) {
        apiClient
          .postData(USER_BASE_URL + CREATE_BANK_ACCOUNT, JSON.stringify(req), token)
          .then((response: any) => {
            let result = response;
            resolve(result);
          })
          .catch((error: any) => {
            let errorMessage = error.message;
            reject(errorMessage);
          });
      }
    });
}

export function getNotificationList(phoneNumber: any, token: any) {
  return (dispatch: (arg0: { type: string }) => void, getState: any) =>
    new Promise((resolve, reject) => {
      dispatch({ type: NOTIFICATIONS_LIST_API });
      const apiClient = APIClient.getInstance();
      if (apiClient) {
        apiClient
          .getRequest(TRANSACTION_BASE_URL + NOTIFICATIONS_API + phoneNumber, token)
          .then((response: any) => {
            let result = response;
            resolve(result);
          })
          .catch((error: any) => {
            let errorMessage = error.message;
            reject(errorMessage);
          });
      }
    });
}

//update noti
export function updateNotificationList(phoneNumber: any, token: any) {
  return (dispatch: (arg0: { type: string }) => void, getState: any) =>
    new Promise((resolve, reject) => {
      dispatch({ type: UPDATE_NOTIFICATIONS_LIST_API });
      const apiClient = APIClient.getInstance();
      if (apiClient) {
        apiClient
          .getRequest(TRANSACTION_BASE_URL + UPDATE_NOTIFICATIONS_API + phoneNumber, token)
          .then((response: any) => {
            let result = response;
            resolve(result);
          })
          .catch((error: any) => {
            let errorMessage = error.message;
            reject(errorMessage);
          });
      }
    });
}

export function getUSerInfo(req: any, token: string) {
  return (dispatch: (arg0: { type: string }) => void, getState: any) =>
    new Promise((resolve, reject) => {
      dispatch({ type: GET_MUTUAL_FUND__CUSTOMER_WORKFLOW_USER_GET });
      const apiClient = APIClient.getInstance();
      if (apiClient) {
        apiClient
          .postData(API_BASE_URL + MF_USER_INFO, JSON.stringify(req), token)
          .then((response: any) => {
            let result = response;
            resolve(result);
          })
          .catch((error: any) => {
            let errorMessage = error.message;
            reject(errorMessage);
          });
      }
    });
}

export function updateProfilePhoto(
  req: Models.PROFILE_UPLOAD_REQUEST,
  token: string
) {
  return (dispatch: (arg0: { type: string }) => void, getState: any) =>
    new Promise((resolve, reject) => {
      dispatch({ type: PROFILE_PHOTO });
      const apiClient = APIClient.getInstance();
      if (apiClient) {
        apiClient
          .postData(UPDATE_USER_PIC, JSON.stringify(req), token)
          .then((response: any) => {
            let result = response;
            resolve(result);
          })
          .catch((error: any) => {
            let errorMessage = error.message;
            reject(errorMessage);
          });
      }
    });
}
